const getCookie = (name) => {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let split = el.split('=');
      cookie[split[0].trim()] = split.slice(1).join("=");
    })

    return cookie[name] ? cookie[name] : false;
}

export default getCookie